export const NEW_CUSTOMER_COUPON_EPPO_ID = 'web-2425-new-customer-coupon';
export const NEW_CUSTOMER_COUPON_EPPO_ID_VALUES = {
  ON: 'v1',
  OFF: 'off',
};

export const BOOKING_ENQUIRY_REBUILD_EPPO_ID = 'web-2479-booking-enquiry-rebuild';
export const BOOKING_ENQUIRY_REBUILD_EPPO_ID_VALUES = {
  ON: 'v1',
  OFF: 'off',
};

export const SHOW_LOGIN_MODAL_ON_UBR_PAGE_LOAD_EPPO_ID = 'web-2604-ubr-show-login-on-page-load';
export const SHOW_LOGIN_MODAL_ON_UBR_PAGE_LOAD_EPPO_ID_VALUES = {
  ON: 'v1',
  OFF: 'off',
};
